/* eslint-disable */
import LazySizes from 'lazysizes';
import 'focus-visible';
import Unveilhooks from 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'modernizr';
/* eslint-enable */

import { onDocumentReady } from './utils';

import Menu from '@src/components/menu';
import InView from './components/in-view';
import Links from '@src/components/links';
import Gauges from '@src/components/gauges';
import VimeoVideo from '@src/components/vimeo-video';
import Tabs from '@src/components/tabs';
import LottieLogoAnimation from './components/logo';
import TestimonialCarousel from '@src/components/testimonial-carousel';
import FeaturedPostsSlider from '@src/components/featured-posts-slider';
import AppSpotlightCarousel from '@src/components/app-spotlight-carousel';
import CardCarousel from '@src/components/card-carousel';
import HangPunctuation from '@src/components/hang-punctuation';
import Accordion from '@src/components/accordion';
import JobList from '@src/components/job-list';
import HomepageHero from '@src/components/homepage-hero';
import LottieAnimation from '@src/components/lottie-animation';
import PricingModule from './components/pricing-module';

new PricingModule();

onDocumentReady(() => {
    new Links();
    new Gauges();
    new LottieLogoAnimation();

    const MENU_CLASS = '.js--menu';

    if (document.querySelector(MENU_CLASS)) {
        new Menu(MENU_CLASS);
    }

    if (document.querySelectorAll('.js-in-view').length) {
        new InView();
    }

    if (document.querySelector('.js-testimonial-carousel')) {
        new TestimonialCarousel();
    }

    if (document.querySelector('.js-featured-posts-slider')) {
        new FeaturedPostsSlider();
    }

    if (document.querySelector('.js-app-spotlight-carousel')) {
        new AppSpotlightCarousel();
    }

    if (document.querySelector('.js-card-carousel')) {
        new CardCarousel();
    }

    if (document.querySelector('.js-hang-punc')) {
        new HangPunctuation();
    }

    if (document.querySelector('.js-accordion')) {
        new Accordion();
    }

    const jobList = document.querySelector('.js-job-list');

    if (jobList) {
        new JobList(jobList);
    }

    const homepageHero = document.querySelector('.js-homepage-hero');

    if (homepageHero) {
        new HomepageHero(homepageHero);
    }

    const lottieAnimation = document.querySelector('.js-lottie-animation');

    if (lottieAnimation) {
        new LottieAnimation(lottieAnimation);
    }

    const videos = document.querySelectorAll('.js-vimeo-video[data-video-id]');

    if (videos.length) {
        const script = document.createElement('script');

        script.onload = () => {
            videos.forEach(el => new VimeoVideo(el));
        };

        script.setAttribute('crossorigin', true);
        script.src = 'https://player.vimeo.com/api/player.js';

        document.body.appendChild(script);
    }

    document.querySelectorAll('.js-tabs').forEach(el => new Tabs(el));
});
